import styled from 'styled-components';

export const S = {
  SkeletonContainer: styled.div`
    .ant-list-item {
      border-bottom: none;
    }
  `,
};
